import React, { useMemo } from 'react';
import { ICredentials, IGetPaginatedCredentials } from 'types';
import { ISelectOption } from 'components/Select/types';
import { useFetchData } from 'hooks/useFetchData';
import { getPaginatedCredentials } from 'backend/credentials';
import { AxiosResponse } from 'axios';
import FormSelect from 'components/Select/FormSelect';

interface ICountrySelect {
	setVivaWalletCredentialsId: (value: Nullable<string>) => void;
}

export const VivaWalletCredentialsSelect: React.FC<ICountrySelect> = React.memo(({ setVivaWalletCredentialsId }) => {
	const { response, loading, refetch, responseError } = useFetchData<
		AxiosResponse<ICredentials>,
		IGetPaginatedCredentials
	>(getPaginatedCredentials, {
		pageNumber: 0,
		pageSize: 0,
		name: null,
		sortByName: null,
	});

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.credentialItems.map((el) => ({
				id: el.id,
				name: el.name || '',
			})) || []
		);
	}, [response]);

	return (
		<FormSelect
			testId="VivaWalletCredentialsSelect"
			name="vivaWalletCredentialsId"
			label="ISVCredentialLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setVivaWalletCredentialsId}
		/>
	);
});
